import React from 'react'
import LeftBar from '../Components/LeftBar'
import Dashnav from '../Components/Dashnav'
import BranchesComp from './BranchesComp'

function Branches() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <BranchesComp/>      
        </div>
    </div>
  )
}

export default Branches